<!--
https://xd.adobe.com/view/3bd374d7-9a44-4495-841b-7ee8c9d634b9-6e80/
-->
<template id="projectlist">
<div id="projectlist">
  <div class="col-12" v-if="show">
    <div class="loader"></div>
  </div>
  <div class="flex flex-wrap" v-else>
    <div v-for="(project,index) in status" :key="project.id" class="mb2 mr2 projectcontainer">
      <div class="highlights darkblue-border col-12 px2 py3">
        <div class="flex p0 m0 col-12">
        <p class="h5 semi-bold darkblue line-height-2 mr-auto">{{ project.title }}</p>
        <!-- <p class="ml-auto flex"> 
          <span class="font14 pr1"> Skal Projektet vises : </span>
          <el-checkbox :label="project.title" @change="updateprojectactive(project)" v-model="projectactive"></el-checkbox>
        </p> -->
        </div>
        <p class="h6 regular darkblue line-height-golden" style="height:103px;">{{ project.description | truncate(300, '...') }}</p>
        <div class="p0 m0" v-if="project.pimaryimage">
          <img id="projectmainimage" class="none pointer imageprimary" width="100%" :src="project.pimaryimage.replace('&rotate=90', '').replace('&rotate=180', '').replace('&rotate=270', '').replace('&rotate=0', '')">
        </div>
        <div class="col-12 m0 p0 mt2 flex justify-center items-center">
          <el-radio-group  v-model="projectactive[index]" @change="updateprojectactive(project)" size="medium">
            <el-radio  :label="project.title">Vis på profil</el-radio>
            <!-- <el-radio  label="notaktiv">Vis ikke på profilen</el-radio> -->
          </el-radio-group>
        </div>
        <!-- <div class="mt1 flex justify-start items-center">
          <button v-b-toggle="'collapse' + project.id" class=" border-none p2 flex justify-center items-center my3 not-rounded">
            <span class="relative" style="top:3px;">
              <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M379.9 131.1c-28.4 0-51.5 23.1-51.5 51.5s23.1 51.5 51.5 51.5c28.4 0 51.5-23.1 51.5-51.5C431.4 154.2 408.3 131.1 379.9 131.1zM379.9 214.1c-17.4 0-31.5-14.1-31.5-31.5s14.1-31.5 31.5-31.5c17.4 0 31.5 14.1 31.5 31.5C411.4 200 397.3 214.1 379.9 214.1z"/><path d="M380.2 451.2c-0.2-0.6-0.6-1.2-0.9-1.7 -0.4-0.5-0.8-1.1-1.2-1.5 -0.5-0.5-1-0.9-1.5-1.2 -0.5-0.4-1.1-0.7-1.7-0.9 -0.6-0.2-1.2-0.4-1.9-0.6 -1.3-0.3-2.6-0.3-3.9 0 -0.6 0.1-1.3 0.3-1.9 0.6 -0.6 0.3-1.2 0.6-1.7 0.9 -0.5 0.4-1.1 0.8-1.5 1.2 -0.5 0.5-0.9 1-1.2 1.5 -0.4 0.5-0.7 1.1-0.9 1.7 -0.2 0.6-0.4 1.2-0.6 1.9 -0.1 0.6-0.2 1.3-0.2 2 0 0.7 0.1 1.3 0.2 2 0.1 0.6 0.3 1.3 0.6 1.9 0.3 0.6 0.6 1.2 0.9 1.7 0.4 0.6 0.8 1.1 1.2 1.5 0.2 0.2 0.5 0.4 0.7 0.7 0.3 0.2 0.5 0.4 0.8 0.6 0.5 0.4 1.1 0.7 1.7 0.9 0.6 0.3 1.2 0.5 1.9 0.6 0.6 0.1 1.3 0.2 2 0.2 0.7 0 1.3-0.1 2-0.2 0.6-0.1 1.3-0.3 1.9-0.6 0.6-0.2 1.2-0.6 1.7-0.9 0.3-0.2 0.5-0.4 0.8-0.6 0.3-0.2 0.5-0.4 0.7-0.7 0.5-0.5 0.9-1 1.2-1.5 0.4-0.5 0.7-1.1 0.9-1.7 0.3-0.6 0.5-1.2 0.6-1.9 0.1-0.6 0.2-1.3 0.2-1.9s-0.1-1.3-0.2-1.9C380.7 452.4 380.5 451.8 380.2 451.2z"/><path d="M222.9 55.5c-0.2-0.6-0.6-1.2-0.9-1.7 -0.4-0.5-0.8-1.1-1.2-1.5 -0.5-0.5-1-0.9-1.5-1.2 -0.5-0.4-1.1-0.7-1.7-0.9 -0.6-0.2-1.2-0.4-1.9-0.6 -1.3-0.3-2.6-0.3-3.9 0 -0.6 0.1-1.3 0.3-1.9 0.6 -0.6 0.3-1.2 0.6-1.7 0.9 -0.5 0.4-1.1 0.8-1.5 1.2 -0.5 0.5-0.9 1-1.2 1.5 -0.4 0.6-0.7 1.1-0.9 1.7 -0.2 0.6-0.4 1.2-0.6 1.9 -0.1 0.7-0.2 1.3-0.2 2 0 0.7 0.1 1.3 0.2 2 0.1 0.6 0.3 1.3 0.6 1.9 0.3 0.6 0.6 1.2 0.9 1.7 0.4 0.5 0.8 1.1 1.3 1.5 0.5 0.5 1 0.9 1.5 1.2 0.5 0.4 1.1 0.7 1.7 0.9 0.6 0.3 1.2 0.4 1.9 0.6 0.6 0.1 1.3 0.2 2 0.2 0.7 0 1.3-0.1 2-0.2 0.6-0.1 1.3-0.3 1.9-0.6 0.6-0.2 1.2-0.6 1.7-0.9 0.6-0.4 1.1-0.8 1.5-1.2 0.5-0.5 0.9-1 1.2-1.5 0.4-0.5 0.7-1.1 0.9-1.7 0.3-0.6 0.5-1.2 0.6-1.9 0.1-0.6 0.2-1.3 0.2-1.9 0-0.7-0.1-1.3-0.2-2C223.3 56.7 223.1 56.1 222.9 55.5z"/><path d="M456.1 49.3c-6-25.3-28.8-44.3-56-44.3H86.4C38.8 5 0 43.8 0 91.5v313.8c0 31.2 24.9 56.6 55.9 57.5 6 25.3 28.8 44.3 56 44.3H454.5c31.7 0 57.5-25.8 57.5-57.5v-75.5V106.8C512 75.6 487.1 50.2 456.1 49.3zM492 449.4c0 20.7-16.8 37.5-37.5 37.5H111.8c-16 0-29.7-10.1-35.1-24.2 -1.6-4.1-2.4-8.6-2.4-13.3v-6.7 -46.3l114.7-194.5c3.5-5.9 9.7-9.4 16.6-9.3 6.9 0.1 12.9 3.8 16.2 9.8l49.4 90.7 71.8 131.8c1.8 3.3 5.2 5.2 8.8 5.2 1.6 0 3.3-0.4 4.8-1.2 4.9-2.6 6.6-8.7 4-13.6l-23.3-42.8c10.2 0.5 20.3-2.8 28.3-9.5l45-37.3c7.2-6 17.9-5.7 24.8 0.6l2.3 2.2 20 18.3L492 378.4V449.4zM492 351.3l-34.3-31.5 -20-15.2c-13-5.4-28.5-3.6-39.9 5.9l-45 37.3c-4.9 4.1-11.4 5.8-17.7 4.5 -6.3-1.2-11.7-5.1-14.8-10.8l-31.6-57.9 -17.6-32.4v0l-31.8-58.3c-6.8-12.4-19.3-20-33.5-20.3 -14.2-0.2-26.9 6.9-34.1 19.1L74.3 357V106.8c0-20.7 16.8-37.5 37.5-37.5h61.8c5.5 0 10-4.5 10-10s-4.5-10-10-10h-61.8c-31.7 0-57.5 25.8-57.5 57.5v286.9 48.9C35.1 441 20 424.8 20 405.2V91.5c0-36.6 29.8-66.4 66.4-66.4h313.8c16 0 29.7 10.1 35.1 24.2H253.6c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h184.1l20 0.1C476.9 71 492 87.2 492 106.8V351.3z"/></svg>
            </span>
            <span class="h5  semi-bold mx2 mb0">Billeder</span>
            <span class="relative ml2 when-closed" style="top:3px;">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
            </span>
            <span class="relative ml2 when-opened" style="top:3px;">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
            </span>
          </button>
          <button v-if="haaId === '40128'" class="flex justify-center items-center  standard-button p2" v-b-toggle="'video' + project.id" >
            <i class="el-icon-video-camera"></i>
            Video
          </button>
        </div>
        <div>
          <b-collapse ref="picDisplay" :id="'collapse' + project.id">
            <projectimages :project="project" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image" @rorate_image="rorate_image"></projectimages>
          </b-collapse>
          <b-collapse ref="videoDisplay" :id="'video' + project.id">
            <projectvideo :project="project"  @Reload="Reload" @delete_video  ="delete_video" ></projectvideo>
          </b-collapse>
        </div> -->
        <div class="flex flex-column">
          <button class="col-12 facebook-button buttonproject white p1 flex justify-center items-center not-rounded border-0 my1" @click="shareproject(project.ProjectURL)">
            <span class="mr1 relative">
                <img src="/static/svg/facebook.svg" alt="" width="20" height="20">
              </span>
            <span class="h6 pl1 mb0">Del på Facebook</span>
          </button>
          <button class="col-12 action-button border-0 buttonproject p1 flex justify-center items-center not-rounded mb1" @click="editPorject(project)">
            <span class="relative">
              <svg fill="currentColor" width="20" height="20" viewBox="0 0 512.00034 512" xmlns="http://www.w3.org/2000/svg"><path d="m130.140625 367.523438c-3.898437 3.902343-3.898437 10.230468 0 14.140624 3.910156 3.898438 10.242187 3.898438 14.152344 0 3.898437-3.910156 3.898437-10.238281 0-14.140624-3.910157-3.910157-10.242188-3.910157-14.152344 0zm0 0"/><path d="m330.34375 511.949219c5.523438 0 10-4.476563 10-10 0-5.523438-4.476562-10-10-10h-40c-5.519531 0-10 4.476562-10 10 0 5.523437 4.480469 10 10 10zm0 0"/><path d="m409.558594 17.539062c-3.945313 3.945313-331.960938 331.824219-343.054688 342.914063v.003906c-.003906.003907-.007812.007813-.011718.011719-.816407.820312-1.527344 1.871094-1.957032 2.78125l-63.566406 134.40625c-3.128906 6.613281 1.714844 14.292969 9.039062 14.292969h240.339844c5.523438 0 10-4.476563 10-10 0-5.523438-4.476562-10-10-10h-195.96875l94.195313-44.683594c.929687-.4375 1.957031-1.136719 2.765625-1.945313.007812-.007812.015625-.011718.023437-.019531 0 0 .003907-.003906.003907-.003906 13.441406-13.433594 325.777343-325.632813 343.050781-342.898437 23.441406-23.441407 23.445312-61.414063 0-84.863282-23.394531-23.382812-61.460938-23.378906-84.859375.003906zm7.0625 134.34375c-17.589844-17.589843-38.875-38.875-56.574219-56.574218l21.21875-21.210938 56.578125 56.574219zm-327.800782 301.59375-30.4375-30.445312 18.160157-38.394531 50.648437 50.640625zm55.472657-29.382812-56.574219-56.566406 258.183594-258.078125 21.222656 21.222656-208.695312 208.5625c-3.902344 3.902344-3.90625 10.234375-.003907 14.140625 3.902344 3.90625 10.234375 3.910156 14.144531.003906l208.699219-208.5625 21.207031 21.207032zm-94.992188 18.140625 20.335938 20.339844-38.621094 18.320312zm430.976563-353.980469-28.289063 28.277344-56.578125-56.574219 28.289063-28.273437c15.597656-15.59375 40.980469-15.59375 56.574219-.003906 15.628906 15.625 15.632812 40.949218.003906 56.574218zm0 0"/></svg>
            </span>
            <span class="h6 pl1 mb0">Rediger</span>
          </button>
          <!-- <button class="col-12 outline-delete-button red-background white border-0 buttonproject p1 flex justify-center items-center not-rounded" @click="delProject(project)">
            <span class="relative">
              <i class="el-icon-delete"></i>
            </span>
            <span class="h6 pl1 mb0">Slet</span>
          </button> -->
        </div>
      </div>
    </div>
    <div class="my4" v-if="status.length < 1">
      <p class="center">Intet projekt i øjeblikket.</p>
    </div>
    <b-modal lazy v-model="reviewShow" ref="reviewModal">
      <!-- header -->
      <div slot="modal-header" class="col-12 p2">
        <div class=" line-height-golden">
          <span class="block h6 darkblue regular mb1">Rediger</span>
          <span class="h4 primarycolor">{{ sampleReview.title }}</span>
        </div>
      </div>
      <div class="modal-content border-none">
        <div class="flex flex-column mb3 px2">
          <p class="h6 darkblue  line-height-1 mb1">Titel</p>
          <b-form-input class="muted-background darkblue  h5 regular border-none not-rounded" v-model="sampleReview.title" type="text" required></b-form-input>
        </div>
        <div class="flex flex-column mb2 px2">
          <p class="h6 darkblue  line-height-1 mb1">Kommentar</p>
          <b-textarea variant="secondary" id="textarea1" v-model="sampleReview.description"   :rows="8" class="muted-background darkblue h5 regular  p2 line-height-golden not-rounded border-none" required>
          </b-textarea>
        </div>
      </div>
      <!-- modalFooter -->
      <div slot="modal-footer" class="col-12 px0 flex justify-between items-center">
        <div class="col-6 pr1">
          <button type="buttom" slot="modal-cancel" class="col-12 outlined-disabled-button p2 flex justify-center items-center  h5 not-rounded" @click="hideModal">
            <span>←</span>
            <span class="ml2">Tilbage</span>
          </button>
        </div>
        <div class="col-6">
          <b-btn type="submit" slot="modal-ok" class="col-12 action-button p2 flex justify-center items-center  h5 regular not-rounded" @click="project_service(sampleReview)" :disabled="isLoadingProject">
            <span>Gem</span>
            <span><i class="el-icon-right"></i></span>
          </b-btn>
        </div>
      </div>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</div>
</template>
<script>
// import projectimages from './../uploads/projectimages'
import projectvideo from './../uploads/projectvideo'
import imagefolder from './../uploads/imagefolder'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'statuslist',
  components: {
    // projectimages,
    projectvideo,
    imagefolder,
    loading,
    Simplert,
    ErrorHandler
  },
  data () {
    return {
      status: [],
      isLoadingProject: false,
      sampleReview: [],
      show: false,
      reviewShow: false,
      label: 'Loading...',
      overlay: false,
      projectactive: []
    }
  },
  created () {
    this.Reload()
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1300) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      this.show = true
      var data = {operation: 'myProjectnew', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (!res.projects) {
              window.userGuiding.track('segment', {
                projects: 'false'
              })
            }
            this.status = res.projects
            var m = this
            res.projects.forEach((a, index) => {
              a.images.forEach(b => {
                if (b.isPrimary) {
                  m.status[index]['pimaryimage'] = b.image
                }
              })
              if (a.IsActive && a.IsActive !== null) {
                m.projectactive.push(a.title)
              } else {
                m.projectactive.push('notaktiv')
              }
            })
            this.$emit('UpdateProject', res.url)
            this.show = false
          },
          response => {
            this.$message({
              type: 'error',
              message: response.body.message
            })
            this.show = false
          }
        )
    },
    shareproject (url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank')
    },
    updateprojectactive (item) {
      var status = 1
      var textoutput = ''
      var cancelbuttontext = ''
      var confirmbuttontext = ''
      if (item.IsActive && item.IsActive !== null) {
        textoutput = 'Ønsker du at stoppe med at vise projektet på din profil?'
        cancelbuttontext = 'Annuler'
        confirmbuttontext = 'Gem projekt'
        status = 0
      } else {
        textoutput = 'Ønsker du at vise projektet på din profil ?'
        cancelbuttontext = 'Annuler'
        confirmbuttontext = 'Vis projekt'
        status = 1
      }
      this.$confirm(textoutput, {
        confirmButtonText: confirmbuttontext,
        cancelButtonText: cancelbuttontext,
        type: 'warning'
      }).then(() => {
        this.salesPerson = localStorage.getItem('id_token_portal')
        this.haaId = localStorage.getItem('haaid')
        var dataPartner = {
          operation: 'toggle_project',
          salesPerson: this.salesPerson,
          levid: this.haaId,
          active: status,
          caseid: item.projectid ? item.projectid : ''
        }
        this.$http.post('', dataPartner, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: 'Success'
                })
                this.Reload()
              } else {
                this.Reload()
              }
            },
            response => {
              this.$message({
                type: 'error',
                message: response.body.message
              })
            }
          )
      }).catch(() => {
      })
    },
    delProject (item) {
      var textoutput = ''
      // if (item.IsDeleted) {
      //   textoutput = 'Er du sikker på, at du ikke vil fortryde sletningen af dette projekt?'
      // } else {
      textoutput = 'Er du sikker på, at du vil slette?'
      // }
      this.$confirm(textoutput, {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        this.salesPerson = localStorage.getItem('id_token_portal')
        this.haaId = localStorage.getItem('haaid')
        var dataPartner = {
          operation: 'delProject',
          salesPerson: this.salesPerson,
          levid: this.haaId,
          projectid: item.projectid ? item.projectid : ''
        }
        this.$http.post('', dataPartner, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: 'Success'
                })
                this.Reload()
              } else {
                this.Reload()
              }
            },
            response => {
              this.show = false
              this.$message({
                type: 'error',
                message: response.body.message
              })
            }
          )
      }).catch(() => {
      })
    },
    editPorject (item) {
      this.$router.push('/opret-projekt-new/rediger_projekt?id=' + item.projectid)
    },
    delete_video (videoId, projectid) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'delete_video_project', salesPerson: this.salesPerson, levid: this.haaId, videoId: videoId, projectid: projectid}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    project_service (item) {
      this.isLoadingProject = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'project_update', salesPerson: this.salesPerson, levid: this.haaId, projectid: item.projectid, title: item.title, description: item.description}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingProject = false
            if (res.success) {
              this.hideModal()
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
              this.isLoadingProject = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showItemDetails (project) {
      this.reviewShow = !this.reviewShow
      this.sampleReview = project
    },
    hideModal () {
      this.$refs.reviewModal.hide()
    },
    delete_image (imageId, projectid) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    rorate_image (imageId, projectid, image, primary) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'rotate_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        primary: primary,
        image: image,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    SaveImage (imageId, projectid) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'image_position_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    }

  }

}
</script>
<style>
.modal-header,
.modal-content,
.modal-footer {
  border: 0;
}
#projectlist .projectcontainer {
  width: 430px;
}
#projectlist .imageprimary {
  height: 233px;
}
#projectlist .buttonproject {
  height: 40px;
}
#projectlist .el-checkbox__label {
  display: none;
}
#projectlist  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
#projectlist  .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#projectlist  .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#projectlist  .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#projectlist  .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@media screen and (max-width: 450px) {
  .el-radio__label {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// NewStatusListnew.vue?85da3cb4